import {MapActionsPolicyModel} from "@core/model/aux/map-actions-policy.model";
import {Action, createReducer, on} from "@ngrx/store";
import {mapActions} from '@core/ngrx/actions'
import { FeatureCollection } from 'geojson';
import _ from "lodash";
import {DistanceUnits, UserMap} from "@core/model/user-map";

export interface State {
  userMap: UserMap,
  mwThreshold: number,
  units: DistanceUnits,
  mapActionsPolicy: MapActionsPolicyModel,
  originalMarkersGeoJson: FeatureCollection | null;
  isClusterMode: boolean;
}

export const initialState: State = {
  userMap: null,
  mwThreshold: 0,
  units: DistanceUnits.MILES,
  mapActionsPolicy: {
    canInteractWithMarkers: false,
    canDisplayMarketCircles: false,
    canDisplayLines: true,
    canDisplayPolygons: true,
    canDisplayPolygonInfos: true
  },
  originalMarkersGeoJson: null,
  isClusterMode: false
}

const mapReducer = createReducer(
  initialState,
  on(mapActions.toggleMapAction, (state, action) => {
    const modifiedMapActions = _.cloneDeep(state.mapActionsPolicy)
    modifiedMapActions[action.mapAction] = !modifiedMapActions[action.mapAction];
    return {
      ...state,
      mapActionsPolicy: modifiedMapActions
    };
  }),
  on(mapActions.loadUserMapSuccess, (state, action) => {
    let userMap: UserMap = _.cloneDeep(action.userMap);
    return {
      ...state,
      userMap: userMap,
      mwThreshold: action.userMap.mwThreshold,
      units: action.userMap.units ? action.userMap.units : DistanceUnits.MILES
    }
  }),
  on(mapActions.saveOriginalMarkersGeoJson, (state, action) => {
    return {
      ...state,
      originalMarkersGeoJson: action.geoJson
    };
  }),

  on(mapActions.toggleClusterMode, (state, action) => {
    return {
      ...state,
      isClusterMode: action.cluster,
    };
  }),
);

export function reducer(state: State | undefined, action: Action): any {
  return mapReducer(state, action);
}
